import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsDiameterSizeS from './IconToolsDiameter_size_s';

const props: CreateIconArguments = {
  l: IconToolsDiameterSizeS,
  m: IconToolsDiameterSizeS,
  s: IconToolsDiameterSizeS,
  xs: IconToolsDiameterSizeS,
  name: 'IconToolsDiameter',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
